const styles = theme => ({
  mainContainer: {
    display: "flex",
    justifyContent: "space-between",
    height: "100vh",
    flexDirection: "column",
    fontFamily: "Titillium-Regular, Helvetica Neue, sans-serif",
    fontSize: "14px"
  },
  // header start from here
  header: {
    backgroundColor: "#ea4367",
    color: "#fff",
    height: "60px"
  },
  headerContainer: {
    maxWidth: "1200px",
    margin: "0 auto",
    height: "60px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "0 15px",
    [theme.breakpoints.down("sm")]: {
      paddingRight: "0"
    }
  },
  userName: {
    [theme.breakpoints.down("xs")]: {
      display: "none"
    }
  },
  circle: {
    height: "25px",
    width: "25px",
    backgroundColor: "#fde6e6",
    borderRadius: "50%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontFamily: "montserratblack, Helvetica Neue, sans-serif",
    fontSize: "10px",
    fontWeight: "900",
    color: "#cb2a49",
    marginRight: "7px",
    [theme.breakpoints.down("xs")]: {
      marginRight: "0px"
    }
  },
  brandImage: {
    height: "36px"
  },
  dropdownMenu: {
    display: "flex",
    alignItems: "center"
  },
  // header end here

  profileContainer: {
    padding: "19px 28px 27px",
    margin: "0 auto",
    width: "100%",
    maxWidth: "549px",
    color: "#323233",
    borderRadius: "2px",
    boxShadow: "0 13px 34px 0 rgba(88, 99, 125, 0.1)"
  },
  profileHeading: {
    fontSize: "26px",
    fontFamily: "Titillium-SemiBold, Helvetica Neue, sans-serif",
    marginBottom: "15px"
  },
  profileSubHeading: {
    fontSize: "14px",
    fontFamily: "Titillium-SemiBold, Helvetica Neue, sans-serif",
    textTransform: "uppercase",
    marginTop: "30px"
  },
  editProfileButton: {
    fontSize: "14px",
    fontFamily: "Titillium-SemiBold, Helvetica Neue, sans-serif",
    textTransform: "uppercase",
    width: "165px",
    height: "40px",
    marginTop: "30px"
  },
  profileTextField: {
    width: "90%"
  },
  footerText: {
    margin: "auto auto 20px",
    fontSize: "13px",
    color: "#58637d"
  },
  // admin menu
  adminMenu: {
    marginRight: "50px",
    [theme.breakpoints.down("sm")]: {
      position: "absolute",
      zIndex: "999",
      width: "100%",
      top: "60px",
      left: "0",
      background: "#ea4367",
      marginRight: "0",
      paddingBottom: "20px",
      whiteSpace: "nowrap",
      overflow: "auto"
    }
  },
  adminMenuLink: {
    color: "#f1a9a9",
    fontSize: "14px",
    fontWeight: "500",
    fontFamily: "montserratregular, Helvetica Neue, sans-serif",
    marginRight: "55px",
    position: "relative",
    textDecoration: "none",
    [theme.breakpoints.down("sm")]: {
      margin: "0 10px",
      fontWeight: "600"
    },
    "&:hover": {
      textDecoration: "none"
    }
  },

  activeMenuLink: {
    color: "#fff",
    "&::before": {
      content: `''`,
      position: "absolute",
      width: "95px",
      height: "3px",
      background: "#fff",
      left: "0",
      right: "0",
      top: "0",
      bottom: "-56px",
      margin: "auto",
      [theme.breakpoints.down("sm")]: {
        display: "none"
      }
    }
  },
  menuDropdown: {
    top: "45px",
    borderRadius: "0",
    "& li": {
      minWidth: "180px",
      fontSize: "13px",
      fontFamily: "Titillium-Regular, Helvetica Neue, sans-serif",
      "&:focus": {
        background: "none"
      }
    }
  },
  LogoutTab: {
    color: "#cb2a49",
    "& img": {
      marginRight: "7px"
    }
  }
});
export default styles;
